export const ON_CANCEL_DELIVERY_REQUEST = {
    REQUEST: 'DELIVERY_REQUEST.CANCEL_DELIVERY_REQUEST.REQUEST',
    SUCCESS: 'DELIVERY_REQUEST.CANCEL_DELIVERY_REQUEST.SUCCESS',
    FAILED: 'DELIVERY_REQUEST.CANCEL_DELIVERY_REQUEST.FAILED',
};

export const BEGIN_CANCEL_DELIVERY_REQUEST = "DELIVERY_REQUEST_BEGIN_CANCEL_DELIVERY_REQUEST";
export const END_CANCEL_DELIVERY_REQUEST = "DELIVERY_REQUEST_END_CANCEL_DELIVERY_REQUEST";
